export type SignupPlan = 'essentials' | 'pro' | 'enterprise' | 'partner'

export function readSelectedSignupPlan(): SignupPlan | null {
  try {
    const plan = new URLSearchParams(window.location.search).get('plan')?.toLowerCase().trim()
    if (plan === 'essentials' || plan === 'pro' || plan === 'enterprise' || plan === 'partner') return plan
    const stored = window.localStorage.getItem('fg_selected_plan')?.toLowerCase().trim()
    if (stored === 'essentials' || stored === 'pro' || stored === 'enterprise' || stored === 'partner') return stored
  } catch { /* ignore unavailable browser storage */ }
  return null
}
